import { Grid, Stack, styled } from "@mui/material";
import React from "react";
import PaidBaseSupplierInfors from "./PaidBaseSupplierInfors";
import PaidContactSupplier from "Components/sections/PaidContactSupplier";
import { useSupplierContext } from "..";
import useBreakpoints from "hooks/useBreakpoint";

type Props = {};

const PaidBanner = (props: Props) => {
  const { supplierDetail } = useSupplierContext();
  const { isMobile } = useBreakpoints();

  return (
    <StyledPaidBanner alignItems="center">
      <Grid container paddingX={{ xs: 0, md: "120px" }}>
        <Grid xs={12} md={8}>
          <PaidBaseSupplierInfors />
        </Grid>

        {!isMobile && (
          <Grid xs={12} md={4}>
            <PaidContactSupplier supplierId={supplierDetail?.farm_id} />
          </Grid>
        )}
      </Grid>
    </StyledPaidBanner>
  );
};

const StyledPaidBanner = styled(Stack)(({ theme }) => ({
  background: "linear-gradient(to top, #FFFFFF 0%, #B6F0CB 100%)",
  paddingTop: 24,
  paddingBottom: 24,

  [theme.breakpoints.down("md")]: {
    padding: 8,
  },
}));

export default PaidBanner;
